import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { styled } from "@mui/system";
import NoRowsOverlay from "../components/NoRowsOverlays";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
    "& .MuiDataGrid-cell:focus": {
        outline: "none",
    },
}));

export default function DataGridTable(props) {
    const location = useLocation();
    const { columns, rows, handleRowSelection, tableHeight, loading = false } = props;

    const [pageSize, setPageSize] = useState(7);

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    return (
        <div style={{ height: `${tableHeight ?? '80vh'}`, width: '100%' }} className="client-table-custom-style">
            <CustomDataGrid
                columns={columns}
                rows={rows}
                // autoHeight
                checkboxSelection
                onSelectionModelChange={handleRowSelection}
                disableSelectionOnClick
                slots={{
                    noRowsOverlay: NoRowsOverlay,
                }}
                pageSize={pageSize}
                onPageSizeChange={handlePageSizeChange}
                rowsPerPageOptions={[7, 14, 21]}
                loading={loading}
            // getRowId={(row) => row.tableid}
            // rowSelectionModel={rowSelectionModel}
            />
        </div>
    )
}

